






















import { Store } from '@/model/Store';
import {Component, Prop, Vue} from 'vue-property-decorator';
import formatStoreLabel from '@/filters/StoreLabelFormatter';
import formatStoreId from '@/filters/StoreIdFormatter';
import ZoneFilter, { ZoneFilterBehaviour } from '@/components/ZoneFilter.vue';

@Component({
  filters: {formatStoreLabel, formatStoreId},
  components: {ZoneFilter}
})
export default class StoreParams extends Vue {

    @Prop({}) store: Store;

    // Expose enums to the vue
    protected ZoneFilterBehaviour = ZoneFilterBehaviour;

    private onClickReturn() {
        this.$emit("onReturnStoresPage");
    }
}

